import script from "./UserBookedCounselling.vue?vue&type=script&setup=true&lang=js"
export * from "./UserBookedCounselling.vue?vue&type=script&setup=true&lang=js"

import "./UserBookedCounselling.vue?vue&type=style&index=0&id=19b74c10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19b74c10"]])

export default __exports__